export function rangeArray(length: number) {
  return Array.apply(null, Array(length)).map((_, i) => i);
}
